module.exports = __webpack_public_path__ + "img/40_38_083_970.55b9cee8.jpg";